import React from 'react'
import Footer from '../../Layout/Footer'
import Header from '../../Layout/Header'
import FAQ from './FAQ'
import SeoTagsFooter from './SeoTagsFooter'

function RefundCancellation() {
  return (
    <div className="page_wrapper">
      <Header/>
      <main className="page_content">

        {/* Page Header */}
        <section 
          className="page_header text-center bg-dark section_decoration overflow-hidden" 
          style={{backgroundImage :"url('assets/images/backgrounds/page_header_bg_1.webp')"}}
        >
          <div className="container">
            <h1 className="page_title text-white">Refund &amp; Cancellation Policy</h1>
            <ul className="breadcrumb_nav unordered_list justify-content-center">
              <li><a href="/">Home</a></li>
              <li className="active"><a href="#!">Refund &amp; Cancellation</a></li>
            </ul>
          </div>
          <div className="decoration_item shape_nate">
            <img src="assets/images/shapes/shape_nate.svg" alt="Shape Nate"/>
          </div>
        </section>

        {/* Refund & Cancellation Content */}
        <section className="feature_section section_space">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="heading_block mb-4 text-center">
                  <p className="heading_description mb-0" style={{textAlign:'left'}}>
                    At Mokshiq (a product of <strong>Rakle Service Private Limited</strong>), we strive to provide seamless and secure financial services. 
                    Please review our Refund &amp; Cancellation policy carefully.
                  </p>
                </div>

                <div className="policy_content">
                  <h4>1. Service-Based Transactions</h4>
                  <p>
                    All payments made towards services such as AEPS, DMT, mATM, mobile/DTH recharge, Verify API credits, 
                    utility bill payments, and other digital transactions are final once successfully processed.
                  </p>

                  <h4>2. Cancellation Policy</h4>
                  <p>
                    Since Mokshiq offers instant digital financial services, cancellations are not possible 
                    once a transaction has been submitted to banking/biller nodes. Users are advised to verify transaction details 
                    before confirming payment.
                  </p>

                  <h4>3. Refund Policy</h4>
                  <p>
                    Refunds will only be processed in the following cases:
                  </p>
                  <ul>
                    <li>Amount debited from wallet/bank but the transaction failed at the operator or bank end.</li>
                    <li>Duplicate payment due to technical network glitch (auto-refund webhook triggered).</li>
                    <li>Payment made but requested API credit was not assigned due to system issues.</li>
                  </ul>
                  <p>
                    In such cases, auto-refund or manual settlement will be completed to the original wallet/bank source within 
                    <strong> 24-48 working hours</strong>.
                  </p>

                  <h4>4. Support &amp; Ticket Resolution</h4>
                  <p>
                    For refund queries or transaction status checks, raise a ticket via support email: <br/>
                    Email: <a href="mailto:support@mokshiq.in">support@mokshiq.in</a> | Phone: <a href="tel:+917311104571">+91 7311104571</a><br/>
                    Address: 1st Floor, C 78, Sector-2 Noida, Uttar Pradesh
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <FAQ 
          title="Refund & Settlement FAQs"
          subtitle="Learn how Mokshiq handles transaction refunds, failed payments, and wallet credit reconciliations."
        />

      </main>
      <Footer/>
      <SeoTagsFooter/>
    </div>
  )
}

export default RefundCancellation
